/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import { CommonGlassContainer, Grid, Label } from "assets/styles/globalStyles";

// Types
import {
    FounderWrapper,
    ReadMoreButton
} from "./styles";

// Components
import Loader from "components/Loader";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { NewsMediaItem, ProjectItem } from "pages/Homepage/styles";
import { FontSizes, FontWeight } from "utils/enums";
import AOS from "aos";
import ArticleView from "pages/AwardList/ArticleView";
import { Flex } from "antd";
import { colors } from "assets/styles/colors";
import Statement from "modals/Statement";

const Projects: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [projects, setProjects] = useState<any[]>([]);
    const [isOpenArticle, setOpenArticle] = useState(false);
    const [article, setArticle] = useState<any>(null);
    const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
    const [projectData, setProjectData] = useState<any>(null);
    
    const handleProjectMore = (item: any) => {
        setProjectData(item)
        setIsProjectModalOpen(true)
    }

    // AOS Initialization
    useEffect(() => {
        AOS.init({ duration: 800, easing: 'ease-in-out', once: false });
        const handleScroll = () => AOS.refresh();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Fetch Projects when language or page changes
    useEffect(() => {
        const fetchProjects = async () => {
            setLoading(true);
            try {
                const res = await fetchData(restAPIs.projectsList(currentLang?.id));
                setProjects(res.projects);
            } catch (error) {
                console.error("Failed to fetch Projects:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProjects();
    }, [currentLang]);

    const handleOpenArticle = (item: any) => {
        setArticle(item);
        setOpenArticle(true);
    };

    return (
        <>
            <FounderWrapper direction={currentLang?.id === 1 ? "rtl" : "ltr"}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <CommonGlassContainer>
                                <motion.div
                                    className='mb-5'
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    <Label
                                        fontSize={FontSizes.h1}
                                        fontWeight={FontWeight.bold}
                                        marginTop={0}
                                        marginBottom={5}
                                    >
                                        {t('projects')}
                                    </Label>
                                </motion.div>

                                <Grid data-aos="fade-right" col={2} gap={30} >
                                    {projects && projects.map((item: any, i: any) => {
                                        return (
                                            <ProjectItem data-aos="fade-left" data-aos-delay={2 * 200} >
                                                <img src={item?.picture} alt="" className="__left" />
                                                <img src={item?.personPicture} alt="" className={currentLang?.lang === "ar" ? "rtl __left__absolute" : "ltr __left__absolute"} />
                                                <div className="____content">
                                                    <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h3} marginBottom={3} >
                                                        {item?.name}
                                                    </Label>

                                                    <Label fontWeight={FontWeight.bold} color={colors.secondary} fontSize={FontSizes.h6} marginBottom={10}>
                                                        <span style={{ color: colors.secondary }} dangerouslySetInnerHTML={{ __html: item?.subtitle }}></span>
                                                    </Label>
                                                    <p>{item?.subbody}</p>
                                                    <button onClick={() => handleProjectMore(item)}>More</button>
                                                </div>
                                            </ProjectItem>
                                        );
                                    })}
                                </Grid>
                            </CommonGlassContainer>
                            {isLoading && <Loader />}                            
                        </div>
                    </div>
                </div>
            </FounderWrapper>
            <Statement
                open={isProjectModalOpen}
                onClose={() => setIsProjectModalOpen(false)}
                data={projectData}
            />
        </>
    );
};

export default Projects;
